import Activities from './activitiesEnum';

/**
 * Activities that should be excluded from tag displays.
 * These are still valid activities returned by the API but are filtered out
 * from UI components like Tags and NearbyTrails filters.
 */
const excludedActivityTags: Activities[] = [Activities.HIKING];

export default excludedActivityTags;
